import FleetCoachBulkUpload from "../../../views/FleetCoachBulkUpload.js";
import FleetCoachBulkUploadV2 from "../../../views/FleetCoachBulkUploadV2";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const FleetCoachBulkUploadRoutes = [
  {
    menuName: MenuNames.FLEET_COACH,
    path: "/Fleet-Coach-Bulk-Upload",
    component: FleetCoachBulkUpload,
    exact: true,
  },
  {
    menuName: MenuNames.FLEET_COACH_V2,
    path: "/v2/Fleet-Coach-Bulk-Upload",
    component: FleetCoachBulkUploadV2,
    exact: true,
  },
];

export default FleetCoachBulkUploadRoutes;
